import { render } from "./VenueStats.vue?vue&type=template&id=3c7d674a"
import script from "./VenueStats.vue?vue&type=script&lang=js"
export * from "./VenueStats.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./VenueStats.vue?vue&type=style&index=0&id=3c7d674a&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__